import React from 'react';
export const drinkInfo = {
    data: [
        {
            title: "蟬吃蜂蜜綠",
            rootinfo: {
                description: "與契作蜂農合作，使用通過台灣養蜂協會認證，取得「國產蜂產品認證標章」的【天然百花蜂蜜】，搭配台灣南投自然農法的【蟬吃烏龍綠茶】，烏龍茶的回甘中略帶百花蜂蜜淡淡柑橘花香，令人驚艷的絕佳風味，一如令人驚艷的你！",
                image: "蜂蜜綠2.png",
                style: { className: "imgdiv" }
            },
            detail: {
                image: "DM/蟬吃蜂蜜綠2.jpg"
            }
        },
        {
            title: "鮮檸冷泓青",
            rootinfo: {
                description: "自然農法的生機檸檬，搭上高山冷泓青茶特殊的冷泓氣味，鮮爽酸甜，餘韻繞口，忘不了的好滋味。杯中健康自然的生機檸檬片更可取出食用，把整顆檸檬的營養一起入口。",
                image: "鮮檸冷泓青2.png",
                style: { className: "imgdivN001" }
            },
            detail: {
                image: "DM/鮮檸冷泓青2.jpg"
            }
        },
        {
            title: "蟬吃鮮翠烏龍茶",
            rootinfo: {
                winword: "參加冬季鹿鳴自然生態烏龍茶大賽榮獲「特優」",
                description: "鮮採翠嫩的自然生態茶菁\n輕發酵中烘焙\n入口呈現輕發酵所保留的烏龍茶清香\n落喉展現中烘焙的甘潤醇甜\n這是老製茶師的巧奪造化\n成就一道令人愛不釋手的難得好茶",
                image: "topone/鮮脆烏龍茶-特優-655x962.png",
                style: { className: "imgdiv" }
            },
            detail: {
                image: "DM/鮮翠烏龍.png"
            }
        },
        {
            title: "高山冷泓青",
            rootinfo: {
                description: "來自台灣高冷茶區種植的青心烏龍，得天獨厚的地理環境，孕育出獨特的冷泓氣味，清淡而優雅，溫潤而滑順，喝上一口，令人久久不能忘懷。",
                image: "冷泓清2.png",
                style: { className: "imgdiv" }
            },
            detail: {
                image: "DM/高山冷泓青2.jpg"
            }
        },
        {
            title: "蟬吃金玉紅",
            rootinfo: {
                description: "蟬吃茶自然農法系列的茶品，以金萱紅茶和紅玉紅茶特調，紅玉紅茶的淡淡肉桂香搭配金萱紅茶的甘甜蜜香，清雅的止不住口。",
                image: "金玉紅2.png",
                style: { className: "imgdiv" }
            },
            detail: {
                image: "DM/金玉紅50x70.jpg"
            }
        },
        {
            title: "珍珠金玉拿鐵",
            rootinfo: {
                description: "蟬吃茶的招牌特調金玉紅茶，以南投自然農法的金萱及紅玉紅茶特調而成，金萱紅的蜜甜香與紅玉紅淡淡的肉桂香，搭配有鮮奶界LV之稱的高大鮮奶所蹦出的香醇鮮奶茶，再加上自然香Q的紅麴山藥珍珠，喝上一口便讓人停不下來！",
                image: "珍珠金玉拿鐵2.png",
                style: { className: "imgdiv" }
            },
            detail: {
                image: "DM/珍珠金玉拿鐵2.jpg"
            }
        },
        {
            title: "蟬吃手採蜜香紅",
            rootinfo: {
                description: "自然農法，被小綠葉蟬吸允過的茶葉\n經過基本的烘焙後，產生獨特的天然蜜果香氣。茶湯深如琥珀，口感溫潤，總是讓人忍不住一喝再喝，回味無窮。",
                image: "蜜香紅2.png",
                style: { className: "imgdiv" }
            },
            detail: {
                image: "DM/蟬吃蜜香紅2.jpg"
            }
        },
        {
            title: "蟬吃手採佳葉龍",
            rootinfo: {
                description: "味甘氣香濃厚醇\n為一種特殊厭氧發酵製程\n而產生天然的γ胺基丁酸\n研究發現此物質舒解壓力幫助入眠\n 故亦名「好睏茶」\n又令人精神旺盛\n故又名「打氣茶」「元氣茶」\n並曾為日本人向天皇進貢的「御用珍品」",
                image: "佳葉龍2.png",
                style: { className: "imgdiv" }
            },
            detail: {
                image: "DM/佳葉龍DM-1107.jpg"
            }
        },
        {
            title: "蟬吃玉山烏龍",
            rootinfo: {
                description: "自然原始的玉山茶園\n得天獨厚的環境孕育出了\n無可比擬的「山頭氣」\n清淡優雅的氣味，喉韻清甜且回甘\n吃上一口，馥香生津\n彷彿徜徉於玉山山林間\n心曠神怡　平靜無爭",
                image: "玉山烏龍2.png",
                style: { className: "imgdiv" }
            },
            detail: {
                image: "DM/玉山烏龍DM-0110.jpg"
            }
        },
        // {
        //     title: "黑糖薑紅",
        //     rootinfo: {
        //         description: <p>用南投自然優質老薑、百年製糖歷史寶山黑糖、台灣明月紅茶製成。黑糖的濃郁、薑的辛辣及紅茶的攝魂香，完美的融合在杯中呈現，是冬季養生的最佳選擇之一。",
        //         image: "黑糖薑紅2.png",
        //         style: { className: "imgdivN001" }
        //     },
        //     detail: {
        //         image: "DM/金玉紅50x70.jpg"
        //     }
        // },
    ]
}

export const interDuce = {
    data: [
        {
            image: "icon-饞.png",
            title: "饞吃茶",
            description: <p>好茶！喝一口就令人愛上了～饞吃茶</p>
        },
        {
            image: "icon-蟬.png",
            title: "蟬吃茶",
            description: <p>茶事自然蟬吃茶<br />友善生物、大地及自己 <br />一杯蟬吃過的好茶，純樸、自然、健康</p>
        },
        {
            image: "icon-禪.png",
            title: "禪吃茶",
            description: <p>透過喝一杯好茶<br />寧靜 專注的活在當下<br />不悔過去，不思未來<br />好好享受當下這杯茶</p>
        },
        {
            image: "icon-潺.png",
            title: "潺吃茶",
            description: <p>好喝、自然健康、心靈寧靜<br />進一步有能量，善予他人，成為轉動世界正向能量的因子<br />如潺潺流水般，涓涓不息！</p>
        },
    ]
}